<template lang="html">
  <div class="container">
    <div class="divider_line">
      <span>基本信息</span>
    </div>
    <div class="one">
      <div class="one-left">
        <div><i class="iconfont">&#xe620;</i>{{detail.full_name | empty('暂无公司信息')}}</div>
        <div><i class="iconfont">&#xe63a;</i>{{detail.address | empty('暂无公司地址')}}</div>
        <div><i class="iconfont">&#xe64f;</i>{{detail.employee_id | deal('employee', 'employee', '暂无公司规模')}}</div>
        <div><i class="iconfont">&#xe632;</i>{{detail.setup_time | timeTrans('暂无注册时间')}}</div>
        <div><i class="iconfont">&#xe650;</i>
          <a :href="detail.main_page | page" target="_blank" v-if="detail.main_page">{{detail.main_page}}</a>
          <template v-else>暂无公司网站</template>
        </div>
        <div><i class="iconfont">&#xe635;</i>{{detail.tel | empty('暂无联系电话')}}</div>
        <div><i class="iconfont">&#xe638;</i>{{detail.email | empty('暂无公司邮箱')}}</div>
      </div>

      <div class="one-right" v-if="news.length!=0">
        <div class="news-module">
          <p class="open_xfly op">
            <img :src="$store.state.static_img_url+'pic/list/cyt3.png'" class="open_xfly_before"/>
              最新报道
            <img :src="$store.state.static_img_url+'pic/list/cyh3.png'" class="open_xfly_after"/>
          </p>
          <div class="check-more" @click="checkMore">
            <span>查看更多</span>
            <i class="iconfont right-icon">&#xe647;</i>
          </div>
          <div @click="go(item.uid)" class="news" v-for="(item, index) in news" v-if="index < 2" :key="index" onclick="_czc.push(['_trackEvent', '机构详情', '最新报道点击'])">
            <div class="news-title">
              {{item.title}}
            </div>
            <div class="news-time">
              <!-- {{item.summary ? item.summary : item.title}} -->
              {{item.create_time | timeTrans}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="two">
      <Divider class="dash-divid" dashed v-if="ntag.length != 0 || detail.summary" />
      <div>
        <div class="summary">
          {{detail.summary}}
        </div>
      </div>
      <span v-if="org_stage_ids.length > 0" >
        <h2 class="p2">机构画像</h2>
        <div class="tag-row">
          <div class="two-left">投资阶段</div>
          <div class="tag">
            <Tag color="default" v-for="item in org_stage_ids" :key="item">{{item | deal('org_stage')}}</Tag>
          </div>
        </div>
      </span>
    </div>
    <div class="three">
      <Divider class="dash-divid" dashed />
      <div class="clear tzfx">
        <span class="spa1">投资分析</span>
        <div>
          <Select class="sel1" v-model="params_tzfx.year" placeholder="请选择年份" @on-change="handleYears" onclick="_czc.push(['_trackEvent', '机构详情', '投资分析时间筛选点击'])">
            <Option value="">全部</Option>
            <Option v-for="item in years" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </div>
      </div>
      <div class="chart_row clear">
          <div id='chart1' class="chart" v-show="echarts_1"></div>
          <div id='chart2' class="chart" v-show="echarts_2"></div>
          <!-- <div id='chart3' class="chart" v-show="echarts_3"></div> -->
          <!-- <div id='chart4' class="chart" v-show="echarts_4"></div> -->
          <!-- <div id='chart5' class="chart" v-show="echarts_5"></div> -->
          <!-- <div id='chart6' class="chart" v-show="echarts_6"></div> -->
      </div>
    </div>
    <div class="four">
      <h2 class="p2 p3">资本事件</h2>
      <div class="list_div">
        <Table :columns="tz_columns" :data="tzfx_list"></Table>
        <div class="page clear" v-if="total > 10">
            <Page :total="total" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator/>
        </div>
      </div>
    </div>
    <!-- <Divider /> -->
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { entityDetail, topicList} from '../../../service'
import filter from 'js/filter'
import echarts from 'echarts'
import { mixin_echart } from 'js/orgbase_mixins'
export default {
  mixins: [mixin_echart],
  inject: ['reload','haddleBackModel'],
  data(){
    return {
      spinShow: true,
      params: {
        uid: this.$route.params.uid,
        type: 'base',
        entity_type: 1
      },
      params_event: {
        uid: this.$route.params.uid,
        type: 'event',
        entity_type: 1
      },
      params_news: {
        entity_uids: [this.$route.params.uid],
        page: 1
      },
      detail: '',
      ntag: [],
      dwtz: [],
      invest: [],
      news: [],
      org_stage_ids: [],
      tz_columns: [
        { title: '投资时间',width: 130, key: 'event_time', render: (h, params) => {return h('span', filter.timeTrans(params.row.event_time))}},
        { title: '投资轮次',width: 80,key: 'round_id',render:(h, params) => {
          if (params.row.type == '1') {
            return h('span', '被并购')
          } else {
            return h('span', filter.deal(params.row.round_id, 'round'))
          }
        }},
        { title: '投资金额',width: 90, key: 'amount', render:(h, params) => {return h('span', filter.amountPrecise(params.row.amount, params.row.unit_id, params.row.precise))}},
        { title: '合投方',minWidth: 150, key: 'tzf', render:(h, params) => {
          if(params.row.tzf.length > 0){
            let tzf = []
            params.row.tzf.map((a,index) => {
              if(a.entity_type == '0' || a.entity_type == '1'){
                tzf.push(h('a', {on: {click: () => {this.goEntityDetail(a.entity_uid, a.entity_type)}}}, a.tz_entity_name))
              }else if(a.entity_type == '2'){
                tzf.push(h('span', a.tz_p_name))
              }else{
                tzf.push(h('span', a.tz_entity_name))
              }
              if(index < params.row.tzf.length-1) tzf.push(h('span', '、'))
            })
            return tzf
          }else{
            return h('span','未透露')
          }
        }},
        { title: '项目名',width: 160, key: 'comp_name', render:(h, params) => {
          return h('div',{
              class: {company: true}
            },[
            h('div',
              {
                on: {click: () => {this.goEntityDetail(params.row.comp_uid, params.row.ht_comp_type)}},
                class: {logo_img: true}
              },[
                h('img', { attrs: {src: filter.logo_show(params.row.ht_comp_logo_path)}})
              ]),
            h('div',
              {class: {company_name: true}},[
                h('div',{class: {company_info: true}}, [
                  h('p', [
                      h('a',{
                        on: {click: () => {this.goEntityDetail(params.row.comp_uid, params.row.ht_comp_type)}}
                      }, params.row.ht_comp_name)
                    ]),
                  h('p',{class: 'company-desc'},filter.empty(params.row.ht_description,'暂无描述')),
                ])
              ])
          ])
        }},
        { title: '行业',minWidth: 150, key: 'tags_arr', render:(h, params) => {
            if (params.row.tags != '') {
              return h('span', filter.dealString(params.row.tags, 'dynview_tag'))
            } else {
              return h('span', '--')
            }
        }},
        { title: '新闻',width: 100, key: 'src',render: (h, params) =>{
          if (params.row.src_url) {
            return h('a', { class:{look_ico:true},attrs: { href: filter.page(params.row.src_url), target: '_blank'}}, [
              h('i', {class: {iconfont: true}, domProps: {
                innerHTML: '&#xe62e;'
              }}),
              h('span','查看来源')
            ])
          } else {
            return h('span', '暂无')
          }
        }},
        { title: '操作',width: 100, key: 'caozuo', render: (h, params) => {
          return h('a', {
              class: {caozuo: true},
              attrs: { href: 'javascript:void(0)'},
              on: {click:() => {this.haddleBackModel()}},
          }, '我要反馈')
        }}
      ]
    }
  },
  computed: {
    uid() {
      return this.$route.params.uid
    },
    dynview_tag() {
      return this.$store.state.dynview_tag
    },
    dynview_tag_type() {
      return this.$store.state.dynview_tag_type
    }
  },
  methods: {
    async getDetail() {
      // 基本信息
      let res = await entityDetail(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'detail', res.info[0])

        let his_arr = localStorage.history_entity ? JSON.parse(localStorage.history_entity) : []
        let index = his_arr.findIndex(a => a == this.detail.id)
        if (index > -1) his_arr.splice(index, 1)
        his_arr.unshift(this.detail.id)
        if (his_arr.length > 5) his_arr.pop()
        localStorage.history_entity = JSON.stringify(his_arr)

        if(this.detail.org_stage_ids){
          this.org_stage_ids = this.detail.org_stage_ids.split(',')
          // console.log(this.org_stage_ids)
        }
        this.$emit('getname', res.info[0])
      } else {
        this.$Message.error(res.msg)
      }
      // 融资（公司对外投资）事件
      let res1 = await entityDetail(this.params_event, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res1.status == 'success') {
        // console.log(res1)
        this.$set(this.$data, 'dwtz', res1.dwtz)
        this.$set(this.$data, 'invest', res1.event)
      } else {
        this.$Message.error(res1.msg)
      }
      // 相关话题
      let res2 = await topicList(this.params_news, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res2.status == 'success') {
        this.$set(this.$data, 'news', res2.res)
      } else {
        this.$Message.error(res2.msg)
      }

      this.spinShow = false
    },
    go(uid) {
      const href = this.$store.state.index2_path + '/newsDetail/' + uid
      window.open(href, '_blank')
    },
    goEntityDetail(uid, type) {
      if (type == 2) {
        // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "PeoDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 1){
        // this.$router.push({name: 'OrgDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "OrgDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 0){
        // this.$router.replace({name: 'CompanyDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
        // this.reload()
      } else if(type == 3){
        // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "HospitalDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      }
    },
    checkMore() {
      this.$emit('gonews', 'news')
    }
  },
  created() {
    this.getDetail()
    this.initCharts()
  },
  watch: {
    uid(val) {
      this.spinShow = true
      this.getDetail()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
$size = 14px
div()
  display: flex
  align-items: center
divAdd()
  margin-top: 20px
.h2
  margin-bottom: 38px
.p2
  padding-top: 24px
  margin-bottom: 14px
  font-weight: bold
  commonColor(#E9E9EB, #333333)
  font-size: 16px
.ivu-select-item-focus
  background: none
.p3
  padding-top: 14px
  padding-left: 18px
.h3
  margin-bottom: 12px
  font-size: 14px
  commonColor(#BCBDC1, #666666)
.container
  padding: 42px 32px 32px 32px
.one
  display: flex
  margin-top: 38px
  padding-left: 18px
  &-left
    width: 60%
    font-size: $size
    a
      color: #188DED
      text-decoration: underline
      &:hover
        color: #69c0ff
    div
      commonColor(#E9E9EB, #333333)
      display: flex
    div+div
      divAdd()
    i
      margin-right: 12px
      font-size: $size
      color: #999
  &-right
    width: 40%
    // margin-right: 30px
.two
  padding-left: 18px
  div
    display: flex
  .tag-row
    margin-top: 8px
  &-left
    flex: 0 0 80px
    min-width: 80px
    font-size: $size
    commonColor(#BCBDC1, #666666)
    vertical-align: top
    line-height: 22px
  .tag
    .ivu-tag
      cursor: default
      margin: 0 8px 8px 0
      border: 0
      commonBgColor(#35383f, #f9f9f9)
      >>> .ivu-tag-text
        commonColor(#949AA2, #666666)
      &:hover
        opacity:1
.three
  padding-left: 18px
  .tzfx
    display: flex
    padding-bottom: 4px
    padding-top: 10px
    .spa1
      flex: 0 0 64px
      commonColor(#fff, #666666)
      font-size: 14px
      line-height: 40px
    .sel1
      width: 268px
      height: 40px
      position: relative
      & >>> .ivu-select-selection
        height: 40px
        background-color: transparent
        commonBorderColor(#7A7F94, #D9D9D9)
        border-radius: 4px
        font-size: 14px
        &:hover
          border: 1px rgba(250, 122, 80, 1) solid
          box-shadow: none
        .ivu-select-placeholder
        .ivu-select-selected-value
          height: 38px
          line-height: 38px
          font-size: 14px
          padding-left: 12px
        .ivu-select-selected-value
          commonColor(#FFFFFF, #666666)
      & >>> .ivu-select-dropdown
          commonBgColor(#2D2F34, #FFFFFF)
          max-height: 178px
          .ivu-select-dropdown-list
            li
              commonColor(#ebebe9, #666666)
              &:hover
                color: rgba(250, 122, 80, 1)
                commonBgColor(#2D2F34, #FFFFFF)
              &.ivu-select-item-selected
                color: rgba(250, 122, 80, 1)
                commonBgColor(#2D2F34, #FFFFFF)
  .chart_row
    margin-top: 16px
    margin-right: -16px
    .chart
      width: calc(50% - 8px)
      height: 300px
      float: left
      margin-right: 16px
      margin-bottom: 16px
      box-shadow:0px 2px 6px 1px rgba(81,84,88,.1)
      &:nth-of-type(even)
        margin-right: 0
.four
  .divider_line
    margin: 36px 0
  .list_div
    padding-left: 18px
// 新闻模块
.news-module
  padding: 24px
  commonBgColor(#2A2F42, #F9F9F9)
  position: relative
  .open_xfly
    position: absolute
    top: 12px
    left: 8px
    line-height: 24px
    color: #fff
    &.op
      background-color: #fcc036
    &_before
      position: absolute
      height: 30px
      width: 12px
      top: 0
      left: -12px
    &_after
      position: absolute
      height: 24px
      width: 16px
      top: 0
      right: -16px
.news
  // margin-top: 15px
  cursor: pointer
  max-width: 500px
  min-width: 250px
  &-title
    width: 100%
    font-size: 16px
    padding-left : 12px
    margin-bottom: 12px
    margin-top: 24px
    commonColor(#E9E9EB, #333333)
    border-left: 2px rgba(250, 122, 80, 1) solid
    ellipsis()
  &-time
    font-size: 14px
    commonColor(#797B83, #666666)
.news:hover
  .news-title
    color: rgba(250, 122, 80, 1)
.check-more
  text-align: right
  font-size: 12px
  color: rgba(250, 122, 80, 1)
  cursor: pointer
  &:hover
    color: #FC9C7C
.ivu-tag+.ivu-tag
  margin-left: 4px
a:hover
  color: rgba(250, 122, 80, 1)
.right-icon
  margin-right: 0 !important
  margin-left: 3px
  font-size: 12px
.ivu-divider-horizontal
  margin: 28px 0 24px 0
.summary
  line-height: 22px
  font-size: 14px
  commonColor(#E9E9EB, #333333)
.dash-divid
  border-top: 1px dashed
  commonBorderColor(#40444F, #E9E9E9)

.ivu-table-wrapper >>> .look_ico
  color: rgba(250, 122, 80, 1)
  .iconfont
    display: inline-table
    vertical-align: top
    font-size: 14px
    margin-right: 4px
  &:hover
    color: #FC9C7C
</style>
